import React from 'react';
import { KnowledgeGraph } from './knowledge/KnowledgeGraph';

export const Knowledge: React.FC = () => {
  return <KnowledgeGraph />;
};
